import { FormStyle, getLocaleMonthNames, TranslationWidth } from '@angular/common';
import { format } from 'date-fns';

export enum GrapheTypeEnum {
  ANNEE = 'annee',
  MOIS = 'mois',
  JOUR = 'jour',
}

export function getGrapheTypeEnumName(locale: string, graphTypeEnum: string, date: Date): string {
  switch (graphTypeEnum) {
    case GrapheTypeEnum.ANNEE:
      return `${date.getFullYear()}`;
    case GrapheTypeEnum.MOIS:
      const localeMonthName = getLocaleMonthNames(locale, FormStyle.Standalone, TranslationWidth.Wide)[date.getMonth()];
      return `${localeMonthName} ${date.getFullYear()}`;
    case GrapheTypeEnum.JOUR:
      return format(date, 'dd/MM/yyyy');
  }
}
